




































































































































































































import { Vue, Component, Lifecycle, Prop, p, Mixin } from "av-ts";
import { ITopic, IQuestionBuilder, IQuestion, IDistractor, IOfferingUser } from "../../interfaces/models";
import { addEventsToQueue } from "../../util";
import TopicService from "../../services/TopicService";
import AuthorService from "../../services/AuthorService";
import UserService from "../../services/UserService";
import ImageService from "../../services/ImageService";
import Fetcher from "../../services/Fetcher";
import tinyMCEPlugins from "./plugins";

import TinyMCE from "../util/TinyMCE.vue";
import TopicChip from "../util/TopicChip.vue";
import Question from "../questions/Question.vue";
import responsiveMixin from "../../responsiveMixin";

@Component({
    components: {
        TinyMCE,
        Question,
        TopicChip
    }
})
export default class AuthorView extends mixin(responsiveMixin, Vue) {

    pTopics: ITopic[] = [];
    @Prop question = p<IQuestionBuilder>({
        default: () => ({
            content: "",
            explanation: "",
            responses: {
                A: "",
                B: "",
                C: "",
                D: ""
            },
            correctIndex: "",
            topics: []
        })
    });
    @Prop id = p<number>({
        default: -1
    });

    @Prop version = p<number>({
        default: 0
    });

    uploadDone = false;
    correctQuestion = "";
    networkMessage = "";
    uploadProgress = 0;
    path = "/questions/add/";
    messageTitle = "Added Question";
    message = "Successfully added question";

    prevDisabled = true;
    prevLabel: string = "Please fill out all question fields to see preview";
    prevTooltip: string | undefined = "Please fill out all question fields to see preview.";
    pDisabled = false;

    currentUser: IOfferingUser;

    bottomSpaceClass: string = "bottomSpace";

    get questionPrev():IQuestion | undefined {
        const error = AuthorService.validateQuestions(this.question);
        let qPrev: IQuestion | undefined;
        if (error === "") {
            let qSolution: IDistractor;

            const qDistractors: IDistractor[] = [
                {
                    id: -1,
                    content: this.question.responses["A"],
                    isCorrect: false,
                    response: "A"
                }, {
                    id: -2,
                    content: this.question.responses["B"],
                    isCorrect: false,
                    response: "B"
                }, {
                    id: -3,
                    content: this.question.responses["C"],
                    isCorrect: false,
                    response: "C"
                }, {
                    id: -4,
                    content: this.question.responses["D"],
                    isCorrect: false,
                    response: "D"
                }
            ];

            //qSolution = qDistractors[0];
            qSolution = {
                id: -5,
                content: "",
                isCorrect: true,
                response: ""
            };
            for (let d of qDistractors) {
                if (d.response == this.question.correctIndex) {
                    d.isCorrect=true;
                    qSolution = d;
                }
            }

            qPrev = {
                id: -1,
                difficulty: 0,
                correctness: 0,
                effectiveness: 0,
                topics: this.question.topics,
                content: this.question.content,
                explanation: this.question.explanation,
                solution: qSolution,
                distractors: qDistractors,
                comments: [],
                responseCount: 0,
                author: this.currentUser,
                removed: false
            };
            this.prevDisabled = false;
            this.prevLabel = "Preview Question";
        } else {
            qPrev = undefined;
            this.prevDisabled = true;
            this.prevLabel = error;
        }
        return qPrev;
    }

    @Lifecycle
    created() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateTopics);
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateUser);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateTopics);
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateUser);
    }

    updateUser(user: IOfferingUser) {
        this.currentUser = user;
    }

    get disabled() {
        return this.pDisabled;
    }

    set disabled(shouldHide: boolean) {
        this.pDisabled = shouldHide;
        const changeEditor = (mode: any) => {
            tinymce.get().forEach((editor: any) => {
                editor.setMode(mode);
            });
        };

        changeEditor(shouldHide ? "readonly" : "design");
    }

    toggleTopic(topicToToggle: ITopic) {
        const topicIndex = this.question.topics.indexOf(topicToToggle);
        if (topicIndex == -1) {
            this.question.topics.push(topicToToggle);
        } else {
            this.question.topics.splice(topicIndex, 1);
        }
    }

    topicIsUsed(topic: ITopic) {
        return this.question.topics.indexOf(topic) >= 0;
    }

    updateTopics(newTopics: ITopic[]) {
        this.pTopics = newTopics;
    }

    get topics() {
        return this.pTopics;
    }

    get options() {
        let imageIndex = tinyMCEPlugins.plugins.indexOf("image");
        if (imageIndex >= 0 && this.mobileMode) {
            tinyMCEPlugins.plugins.splice(imageIndex, 1);
        } else if (imageIndex === -1 && !this.mobileMode) {
            tinyMCEPlugins.plugins.push("image");
        }

        const baseSettings = {
            skin: false,
            image_caption: true,
            media_live_embeds: true,
            plugins: tinyMCEPlugins.plugins,
            toolbar: tinyMCEPlugins.toolbar
        };

        const imageSettings = {
            image_advtab: true,
            file_browser_callback_types: "image",
            file_picker_callback: ImageService.handleFileClick,
            file_picker_types: "image"
        };

        if (!this.mobileMode) {
            return Object.assign(baseSettings, imageSettings);
        }
        return baseSettings;
    }

    navigateToAnswer() {
        this.$router.push("answer");
    }

    validateUpload() {
        const error = AuthorService.validateQuestions(this.question);

        if (error !== "") {
            addEventsToQueue([{
                name: "Invalid Question",
                description: error,
                icon: "error"
            }]);
        } else {
            this.disabled = true;
            if (this.id >= 0) {
                this.path = "/questions/update/"+this.id+"/";
                this.messageTitle = "Updated Question";
                this.message = "Successfully updated question";
            }
            AuthorService.prepareUpload(this.question)
                .then(preparedUpload => {
                    return AuthorService.uploadContent(preparedUpload, this.path);
                })
                .then(response => {
                    addEventsToQueue([{
                        name: this.messageTitle,
                        description: this.message,
                        icon: "done"
                    }]);
                    this.$router.push(`/question/id/${response.id}`);
                });
        }
    }

    selectedTab = 0;
    changeResponseTab(newTab: number) {
        this.selectedTab = newTab;
    }

    tabSelected(index: number) {
        this.selectedTab = index;
        if (index==1) {
            this.bottomSpaceClass="";
        } else {
            this.bottomSpaceClass = "bottomSpace";
        }
    }

    get previewTabStyle() {
        return {
            "previewTabStudent": !this.mobileMode && this.id < 0,
            "previewTabAdmin": !this.mobileMode && this.id >= 0,
            "mobilePreviewTab": this.mobileMode
        };
    }

    get subTabStyle() {
        return {
            "subTabs": !this.mobileMode,
            "mobileSubTabs": this.mobileMode
        };
    }

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/author/AuthorView.vue